export default "/images/invoice.png?f5073c1f3ec0464939832db641c24da4";